var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"dash"},[_vm._v(" — ")])}
var staticRenderFns = []

export { render, staticRenderFns }